export default __webpack_public_path__ + "static/media/connect.759b19ea.png";